import axiosHttpRequest from "../axios";

async function getReport(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData) {
    listViewData = serviceData;
  }
  return listViewData;
}

async function getDailyPositionReport(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  console.log("-----service response ----", serviceResponse);
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.message = serviceData.message;
  listViewInfo.records = listViewData;
  console.log(listViewInfo, "list view data in servicess::::");
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function getSftoJobDeatilsReports(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData) {
    listViewData = serviceData;
  }
  return listViewData;
}

async function rebatesummaryreport(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  console.log("-----service response ----", serviceResponse);
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.message = serviceData.message;
  listViewInfo.records = listViewData;
  console.log(listViewInfo, "list view data in servicess::::");
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function getInvoiceSftoDeatilsReport(
  endpoint,
  queryparams,
  configheaders,
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData) {
    listViewData = serviceData;
  }
  return listViewData;
}

async function downloadSftoInvoiceDetailsReport(
  endpoint,
  filename,
  configheaders,
  postdata,
) {
  axiosHttpRequest.execPostRequestsDownloadFile1(
    endpoint,
    postdata,
    filename,
    configheaders,
  );
}

async function getInvoiceGpwisDeatilsReport(
  endpoint,
  queryparams,
  configheaders,
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData) {
    listViewData = serviceData;
  }
  return listViewData;
}

async function downloadGpwisInvoiceDetailsReport(
  endpoint,
  filename,
  configheaders,
  postdata,
) {
  axiosHttpRequest.execPostRequestsDownloadFile1(
    endpoint,
    postdata,
    filename,
    configheaders,
  );
}

async function getInvoiceReportDetails(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData;
  }

  return listViewData;
}

async function getTATReportList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function getTATReport(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    queryparams,
    configheaders,
  );
  return serviceResponse;
}

async function getRevenueReportList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );

  let serviceData = serviceResponse.data;
  let listViewData = [];
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }

  return listViewData;
}

async function getRevenueReport(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    queryparams,
    configheaders,
  );
  return serviceResponse;
}
async function getRakeRebateReportData(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    queryparams,
    configheaders,
  );
  return serviceResponse;
}

async function getInvoiceList(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  let serviceData = serviceResponse;
  return serviceData.data;
}
async function insertInvoiceData(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    queryparams,
    configheaders,
  );
  return serviceResponse;
}
async function getInvoiceSubmissionReport(
  endpoint,
  queryparams,
  configheaders,
) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  let serviceData = serviceResponse;
  return serviceData.data;
}

async function getConsolidatedDataMGT(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders,
  );
  console.log("-----service response ----", serviceResponse);
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.message = serviceData.message;
  listViewInfo.records = listViewData;
  console.log(listViewInfo, "list view data in servicess::::");
  listViewInfo.paginationInfo = serviceData.paginationinfo;
  return listViewInfo;
}

async function downloadConsolidatedPDFReport(
  endpoint,
  configheaders,
  postdata,
  fileName,
) {
  const serviceResponse =
    await axiosHttpRequest.execPostRequestsDownloadPDFFile(
      endpoint,
      postdata,
      fileName,
      configheaders,
    );
}
async function Mergepdfs(endpoint, configheaders, postdata, fileName) {
  const Response = await axiosHttpRequest.execPostRequestsDownloadPDFFile(
    endpoint,
    postdata,
    fileName,
    configheaders,
  );
}

async function getPendingInvoiceList(endpoint, param, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPutRequest(
    endpoint,
    param,
    postdata,
    configheaders,
  );

  return serviceResponse;
}

async function insertNonLobData(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPostRequest(
    endpoint,
    queryparams,
    configheaders,
  );
  return serviceResponse;
}

async function insertNonLobFile(endpoint, param, postdata, configheaders) {
  const serviceResponse = await axiosHttpRequest.execPutRequest(
    endpoint,
    param,
    postdata,
    configheaders,
  );

  return serviceResponse;
}

export default {
  getReport,
  getDailyPositionReport,
  getSftoJobDeatilsReports,
  rebatesummaryreport,
  getInvoiceSftoDeatilsReport,
  getInvoiceGpwisDeatilsReport,
  downloadSftoInvoiceDetailsReport,
  downloadGpwisInvoiceDetailsReport,
  getInvoiceReportDetails,
  getTATReportList,
  getTATReport,
  getRevenueReportList,
  getRevenueReport,
  getRakeRebateReportData,
  getInvoiceList,
  insertInvoiceData,
  getInvoiceSubmissionReport,
  getConsolidatedDataMGT,
  downloadConsolidatedPDFReport,
  Mergepdfs,
  getPendingInvoiceList,
  insertNonLobData,
  insertNonLobFile,
};
